var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.465.779c-7.165 0-13 5.835-13 13s5.835 13 13 13 13-5.835 13-13-5.835-13-13-13zm4.333 13.433c-.52.722-1.155 1.387-1.848 2.08-.693.693-1.358 1.357-2.08 1.848-2.398 1.705-4.738 2.254-5.75 1.243l-.924-.924c-.231-.26.115-.982.78-1.647s1.415-1.011 1.647-.78l.837.838-.058-.058c.578.578 1.704.404 2.919-.289.52-.318 1.04-.78 1.531-1.27.49-.491.924-.954 1.242-1.474.752-1.243.925-2.398.347-2.976l.057.057-.837-.837c-.231-.231.115-.982.78-1.646.665-.665 1.415-1.011 1.646-.78l.925.924c1.04.982.462 3.293-1.214 5.691z","fill":"#2A87F5"}));
}

Phone.defaultProps = {"width":"27","height":"27","viewBox":"0 0 27 27","fill":"none"};

module.exports = Phone;

Phone.default = Phone;
